// Desbloqueo del audio del juego (regla de autoplay de los navegadores).
// Unity corre en un iframe del mismo origen y expone window.ximaUnlockUnityAudio
// (Plugins/WebGL/XimaAudioUnlock.jslib). Se llama dentro del gesto del usuario:
// al pulsar el botón Tutorial y en cualquier toque/tecla de la página.

const UNLOCK_EVENTS = ["pointerdown", "pointerup", "touchstart", "touchend", "mousedown", "click", "keydown"];

let pagePrimed = false;

const unlockUnityFrames = () => {
  if (typeof document === "undefined") return;
  const frames = document.querySelectorAll("iframe");
  for (let i = 0; i < frames.length; i += 1) {
    try {
      const frameWindow = frames[i].contentWindow;
      if (frameWindow && typeof frameWindow.ximaUnlockUnityAudio === "function") {
        frameWindow.ximaUnlockUnityAudio();
      }
    } catch (_error) {
      // iframe de otro origen: no se toca.
    }
  }
};

// Safari/iOS: arrancar un contexto propio con un buffer mudo dentro del gesto
// deja la página con audio permitido para lo que se cree justo después.
const primePageAudio = () => {
  if (pagePrimed || typeof window === "undefined") return;
  const AudioContextClass = window.AudioContext || window.webkitAudioContext;
  if (typeof AudioContextClass !== "function") return;
  try {
    const context = new AudioContextClass();
    const source = context.createBufferSource();
    source.buffer = context.createBuffer(1, 1, 22050);
    source.connect(context.destination);
    source.start(0);
    if (context.state !== "running") context.resume().catch(() => {});
    pagePrimed = true;
    window.setTimeout(() => {
      context.close().catch(() => {});
    }, 1500);
  } catch (_error) {
    // Sin Web Audio no hay nada que desbloquear.
  }
};

// Llamar de forma síncrona en el manejador del clic (antes de cualquier await).
export const unlockGameAudio = () => {
  primePageAudio();
  unlockUnityFrames();
};

let installed = false;

// Respaldo: el primer toque, clic o tecla en cualquier parte también abre el audio.
export const installGameAudioUnlock = () => {
  if (installed || typeof document === "undefined") return;
  installed = true;
  UNLOCK_EVENTS.forEach((type) => {
    document.addEventListener(type, unlockUnityFrames, { capture: true, passive: true });
  });
};
